<template>
  <div v-if="!loading">
    <v-container>
      <v-form ref="form">
        <v-row>
          <v-col>
            <h2 class="pb-5">{{ this.pageTitle }}</h2>
          </v-col>
        </v-row>

        <!-- <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        > -->
        <v-row>
          <v-col cols="12" sm="6" class="pb-n5 mt-n6">
            <v-autocomplete
              outlined
              :label="this.$t('alleissocso.eissocsosubmissionrec')"
              type="text"
              v-model="formData.eissocsoexprecid"
              :items="eissocsoExpRecList"
              :rules="[rules.required]"
              @change="changeSocsoExportRecord(formData.eissocsoexprecid)"
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="3" class="mb-n1 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('nonbankpaymentlistingreport.payoutyear')"
              type="text"
              v-model="formData.year"
              readonly
              dense
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" class="mb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('bankpaymentlistingreport.payoutmonth')"
              type="text"
              v-model="formData.month"
              readonly
              dense
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" sm="6" class="blue--text ml-2"> {{$t('statutoryexportcommonused.payouts')}} </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="10">
            <v-data-table
              :headers="dataHeader"
              :items="this.payoutItems"
              :options="tableOpt"
              hide-default-footer
              item-key="payoutcode"
            >
            </v-data-table>
          </v-col>
        </v-row>


          <v-row>
              <v-col cols="12" sm="6" class="pb-n5 mt-3">
                  <v-autocomplete
                    outlined
                    :label="this.$t('setupcompanyreferencenumber.referencenumber')"
                    type="text"
                    v-model="formData.socsorefnum"
                    :rules="[rules.required]"
                    :items="eissocsoSubRefRecList"
                     @change="socsoSubRefRecHandler(formData.socsorefnum)"
                    dense
                  ></v-autocomplete>
              </v-col>
          </v-row>

        <!-- <v-row>
          <v-col cols="12" sm="6" class="pb-n5 mt-3">
            <v-text-field
              outlined
              :label="Reference No."
              type="text"
              v-model="formData.socsorefnum"
              :rules="[rules.required]"
              readonly
              dense
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
        </v-row> -->
        <!-- </v-container> -->

        <v-row>
          <div class="pt-5 pl-4 mt-n6">
            <v-btn color="warning" style="width: 100px" @click="displayReport">
              {{$t('button.print')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-error": ErrorDialog,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('reportsparam.invalidemail');
        },
      },
      pageTitle: this.$t('alleissocso.eissocso_8a'),
      dataHeader: [
        { text: this.$t('reportsparam.payout'), value: "payoutcode", width: "150px", sortable: true },
        {
          text: this.$t('statutoryexportcommonused.payoutdescription'),
          value: "payoutdesc",
          width: "300px",
          sortable: true,
        },
        {
          text: this.$t('payrollprocessrun.payoutstatus'),
          value: "pystatusdesc",
          width: "300px",
          sortable: true,
        },
      ],
      formData: {
        eissocsoexprecid: null,
        socsorefnum: null,
        year: null,
        month: null,
        eissocsubrecrefid: null,
        eissocsubrecdpy: [],
        eissocsubrecref: [],
      },

      tableOpt: {
        itemsPerPage: -1,
      },

      items: [],
      dataItems: [],
      salaryExpRecList: [],
      eissocsoExpRecList: [],
      payoutItems: [],
      exportformatItems: [],
      eissocsoSubRefRecList: [],
      // exportFmtList: [],
      notFinalize: false,
      loading: false,
      isErr: false,
      errMsg: "",
      reportFile: "eissocsoBorang8A.rptdesign",
    };
  },

  methods: {
    getSocsoSubRecs() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/eissocsosubmissionrecord/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          console.log(res);
          for (let i = 0; i < res.data.rec.length; i++) {
            vm.eissocsoExpRecList.push({
              text: res.data.rec[i].eissocsubreccode,
              value: res.data.rec[i].id,
            });
          }

          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    getSocsoSubRecPayout(id) {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/eissocsosubmissionrecordpy/" + id})
        .then((res) => {
          vm.payoutItems = res.data.rec;
          vm.formData.eissocsubrecdpy = vm.payoutItems;

          for (let i = 0; i < vm.payoutItems.length; i++) {
            if (vm.payoutItems[i].pystatuscode != 99) {
              this.notFinalize = true;
            } else {
              this.notFinalize = false;
            }
          }

          vm.loading = !vm.loading;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    getSocsoSubRecRef(id) {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/eissocsosubmissionrecordref/" + id})
        .then((res) => {
          vm.formData.eissocsubrecref = res.data.rec;

          //set the eissocsoSubRefRecList array null (to avoid getting value from previous array)
          vm.eissocsoSubRefRecList = [];

           for (let i = 0; i < res.data.rec.length; i++) {
            vm.eissocsoSubRefRecList.push({
              text: res.data.rec[i].socsorefcode + ' - ' + res.data.rec[i].socsorefnum,
              value: res.data.rec[i].socsorefnum,
            });
          }

          //  if(this.formData.socsorefnum){
          //   this.socsoSubRefRecHandler(this.formData.socsorefnum);
          // }

          // if (res.data.rec[0] == undefined) {
          //   vm.formData.socsorefnum = null;
          // } else {
          //   vm.formData.socsorefnum = res.data.rec[0].socsorefnum;
          // }
          
          vm.loading = !vm.loading;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
          vm.loading = !vm.loading;
        });
    },

      socsoSubRefRecHandler(socsorefnum){
       let item = this.formData.eissocsubrecref.find((item) => item.socsorefnum === socsorefnum);

       this.formData.eissocsubrecrefid = item.id;


    },

    changeSocsoExportRecord(id) {
      this.formData.socsorefnum = null;
      let itemExportRecord = this.dataItems.find((item) => item.id === id);

      this.formData.eissocsoexprecid = itemExportRecord.id;
      this.formData.year = itemExportRecord.recyear;
      this.formData.month = itemExportRecord.recmonth;

      this.getSocsoSubRecPayout(id);
      this.getSocsoSubRecRef(id);
    },

    exportHandler() {
      console.log(this.formData);
      if (this.notFinalize) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.payoutnotfinalized');
      } else {
        if (this.$refs.form.validate()) {
          window.open(
            `${this.$store.getters.rptSvrURL}/frameset?__report=report/${this.reportFile}&__format=pdf&id=${this.formData.eissocsoexprecid}&eissocsubrecrefid=${this.formData.eissocsubrecrefid}&userid=${this.$store.getters.userId}&dbname=${this.$store.getters.dbname}`,
            "_blank" // <- This is what makes it open in a new window.
          );
        } else {
          this.isErr = true;
          this.errMsg = this.$t('vdatatable.someinfoismissing');
        }
      }
    },
    
    displayReport() {
      const vm = this;
      const reporturl =  `${this.$store.getters.rptSvrURL}/frameset?__report=report/${this.reportFile}&__format=pdf&id=${this.formData.eissocsoexprecid}&eissocsubrecrefid=${this.formData.eissocsubrecrefid}&userid=${this.$store.getters.userId}&dbname=${this.$store.getters.dbname}`;
      if (this.notFinalize) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.payoutnotfinalized');
      } else {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('post', {
            url: "/reportdisplay/url", 
            payload: {reporturl: reporturl, reportname: this.reportFile},
            responseType: "blob"})
            .then((res) => {
              console.log(res.data);
              if (res.data && res.status == 200) {
                var fileURL = URL.createObjectURL(res.data);
                window.open(fileURL, "_blank");
              } else {
                vm.isErr = true;
                vm.errMsg = res.data.error;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
              }
            })
            .catch((err) => {
              vm.isErr = true;
              vm.errMsg = err;
              vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        } else {
          this.isErr = true;
          this.errMsg = this.$t('vdatatable.someinfoismissing');
        }
      }
    },
  },

  mounted() {
    this.getSocsoSubRecs();
  },
};
</script>